import { Card, Table, Tag } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import axiosInstance from '@/lib/axios'

interface MaintenanceAlert {
  id: number
  vehicle_targa?: string
  vehicle_marca?: string
  vehicle_modello?: string
  tipo?: string
  data_scadenza?: string
  days_until_due?: number
  is_overdue?: boolean
}

const columns = [
  {
    title: 'Veicolo',
    key: 'veicolo',
    render: (_: any, r: MaintenanceAlert) => (
      <span>
        {[r.vehicle_marca, r.vehicle_modello].filter(Boolean).join(' ') || '—'}
        {r.vehicle_targa && <Tag color="geekblue" style={{ marginLeft: 6, fontWeight: 600 }}>{r.vehicle_targa}</Tag>}
      </span>
    ),
  },
  {
    title: 'Tipo',
    dataIndex: 'tipo',
    key: 'tipo',
    render: (v: string) => v ?? '—',
  },
  {
    title: 'Scadenza',
    dataIndex: 'data_scadenza',
    key: 'data_scadenza',
    width: 110,
    render: (v: string) => v ? new Date(v).toLocaleDateString('it-IT') : '—',
  },
  {
    title: 'Stato',
    key: 'stato',
    width: 100,
    render: (_: any, r: MaintenanceAlert) =>
      r.is_overdue
        ? <Tag color="red">Scaduta</Tag>
        : <Tag color="orange">{r.days_until_due != null ? `${r.days_until_due}gg` : 'In scadenza'}</Tag>,
  },
]

export function TableManutenzioniWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<MaintenanceAlert[]>({
    queryKey: ['dashboard', 'maintenance-alerts'],
    queryFn: async () => {
      const res = await axiosInstance.get('/maintenance-schedules/alerts?days_ahead=30')
      return res.data
    },
    staleTime: 60000,
  })

  return (
    <Card size="small" title="Manutenzioni in scadenza">
      <Table
        columns={columns}
        dataSource={data ?? []}
        rowKey="id"
        size="small"
        loading={isLoading}
        pagination={false}
        scroll={{ x: 500 }}
        locale={{ emptyText: 'Nessuna manutenzione in scadenza' }}
        onRow={() => ({ onClick: () => navigate('/maintenance'), style: { cursor: 'pointer' } })}
      />
    </Card>
  )
}
